import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";

import axios from "axios";
import { getData, postData } from "../../../utils/api";

const ReturnCourierViewModal = ({
  show,
  handleClose,
  selectedOrder,
  setShowSuccessModal,
  setSuccessText,
}) => {
  const [loading, setLoading] = useState(false);
  const [couriers, setCouriers] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [shipmentId, setShipmentId] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (show && selectedOrder?.id) {
      setSelectedCourier(null);

      setShipmentId(null);

      setCouriers([]);
      setErrorMessage("");

      fetchCouriers();
    }
  }, [show, selectedOrder]);

  const fetchCouriers = async () => {
    try {
      setLoading(true);

      const response = await getData(
        `/admin/orders/return/couriers/${selectedOrder.id}`,
      );

      console.log(selectedOrder, "Courier response ID");

      setCouriers(response.data?.couriers || []);
      setShipmentId(response.data?.shipment_id || null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCourierSelect = async () => {
    try {
      if (!selectedCourier) {
        return;
      }

      setLoading(true);
      setErrorMessage("");

      const response = await postData(
        `/admin/orders/select-courier/${selectedOrder.id}`,
        {
          shipment_id: shipmentId,
          courier_company_id: selectedCourier,
        },
      );

      if (response?.success === false) {
        setErrorMessage(
          response?.errors || response?.message || "Failed To Assign Courier",
        );
        return;
      }

      handleClose();

      setSuccessText("Courier Assigned Successfully");
      setShowSuccessModal(true);
    } catch (error) {
      console.log(error);

      setErrorMessage(
        error?.response?.data?.errors ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed To Assign Courier",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Return Courier Service</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center p-5">
            <Spinner />
          </div>
        ) : (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="col-compact">Select</th>
                <th className="col-name">Courier</th>
                <th className="col-compact">Rate</th>
                <th className="col-date">Estimated Delivery</th>
                <th className="col-compact">COD</th>
              </tr>
            </thead>

            <tbody>
              {couriers.length > 0 ? (
                couriers.map((courier) => (
                  <tr key={courier.courier_company_id}>
                    <td>
                      <input
                        type="radio"
                        checked={selectedCourier === courier.courier_company_id}
                        onChange={() =>
                          setSelectedCourier(courier.courier_company_id)
                        }
                      />
                    </td>
                    <td>{courier.courier_name}</td>
                    <td>₹{courier.freight_charge}</td>
                    <td>{courier.etd}</td>
                    <td>{courier.cod ? "Yes" : "No"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No couriers found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
        {errorMessage && (
          <div className="alert fw-bold alert-danger">{errorMessage}</div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setSelectedCourier(null);
            setShipmentId(null);
            setCouriers([]);
            handleClose();
          }}
        >
          Close
        </Button>

        <Button variant="primary" onClick={handleCourierSelect}>
          Confirm Courier
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReturnCourierViewModal;
